export default __webpack_public_path__ + "static/media/85.562ac230.png";